<template>
    <div class="p-20 flex flex-col items-center justify-center h-full">
        <alert ref="alert"></alert>

        <div class="md:pb-40 pb-20">
            <h1 class="font-light">{{ $t('are_you_sure') }}</h1>

            <p class="mt-5">
                {{ $t('instance_delete_alert') }}
            </p>

            <div class="mt-10">
                <button class="btn bg-red-400" @click="destroy()" :disabled="loading">
                    {{ $t('yes_delete') }}
                </button>

                <button class="btn btn-blue mt-5" @click="goBack()" :disabled="loading">
                    {{ $t('no_go_back') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            id: String
        },

        inject: ['alert'],

        data() {
            return {
                loading: false
            }
        },

        methods: {
            destroy() {
                this.loading = true;

                Zapin
                    .instances()
                    .destroy(this.id)
                    .then(() => {
                        this.$router.push({
                            name: 'Dashboard'
                        });
                    })
                    .catch(() => {
                        this.alert.show(this.$t('unknown_error_try_again'));
                    })
                    .finally(() => this.loading = false)

            },

            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>